<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardHeader>Hasil Ujian</CCardHeader>
        <CCardBody>
          <div class="form-inline">
            <div class="col-md-6">
              <div class="row">
                <div class="col-md-3">
                  <label>Pilih Series</label>
                </div>
                <div class="col-md-9">
                  <series-selector
                    v-model="data.series"
                    @input="changeSeries"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6">
							<button class="btn btn-success" v-bind:class="{'disabled': !data.series}" @click="exportExcel">Export Excel</button>
						</div>
          </div>
          <br />
          <div style="overflow: inherit">
            <div v-html="resultHtml" style="overflow: auto"></div>
          </div>
        </CCardBody>
        <CCardFooter>
          <content-pagination-2 :paginator="paginate" @change="changePage" />
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>
<script>
import SeriesSelector from "../../components/SeriesSelector.vue";
import ContentPagination2 from "../../components/ContentPagination2.vue";
import { showErrorMessage } from "../../lib/helpers";
import { HTTPAUTH } from "../../lib/httplib";
export default {
  data() {
    return {
      data: {},
      items: {},
      paginate: {
        page: 1,
        size: 10,
        total: 0,
      },
      query: {},
      headers: [],
      resultHtml: ""
    };
  },
  components: {
    SeriesSelector,
    ContentPagination2,
  },
  created() {
    this.query = this.$route.query;
    // var page = 1;
    if (this.query.page) {
      const page = this.query.page;
      console.log(page)
    }
    if (this.query.s) {
      // this.getList(page, this.query.s);
      // this.getHeader(this.query.s);
      this.getListHtml(1, this.query.s);
    }
  },
  methods: {
    changeSeries(s) {
      // this.getHeader(s.id);
      // const query = this.query;
      // if (query.page) {
        // this.getList(query.page, s.id);
      //   return;
      // }
      // this.getList(1, s.id);
      this.getListHtml(1, s.id);
      this.$router.push({query: {s: s.id}})
    },
    // getHeader(seriesId) {
    //   HTTPAUTH.get(
    //     `/api/v1/admin/summary/${seriesId}/question-group`
    //   ).then(res => {
    //     this.headers = res.data.data;
    //   })
    // },
    // getList(page, seriesId) {
    //   HTTPAUTH.get(
    //     `/api/v1/admin/summary/${seriesId}?page=${page}&size=10`
    //   )
    //     .then((res) => {
    //       this.items = res.data.data;
    //       this.paginate = res.data.paginate;
    //       this.setRoute(this.paginate.page, seriesId);
    //     })
    //     .catch((eres) => {
		// 			console.log(eres)
    //       // showErrorMessage(eres);
		// 			this.$toasted.error("Sementara bisa menggunakan fitur download excel").goAway(3000)
    //     });
    // },
    getListHtml(page, seriesId) {
      HTTPAUTH.get(
        `/api/v1/report/exam-result-html?s=${seriesId}&page=${page}&size=10`
      )
        .then((res) => {
          this.resultHtml = res.data.data;
          this.paginate = res.data.paginate;
        })
        .catch((eres) => {
					console.log(eres)
          // showErrorMessage(eres);
					this.$toasted.error("Sementara bisa menggunakan fitur download excel").goAway(3000)
        });
    },
    setRoute(page, seriesId) {
      this.$router
        .push({ query: { page: page, size: 10, s: seriesId } })
        .catch(() => {});
    },
    changePage(page) {
      console.log(page)
      const query = this.$route.query;
      if (query.s) {
        // this.getList(page, query.s);
        return;
      }
      // this.getList(page, "");
    },
		exportExcel() {
			const id = this.data.series.id;
			HTTPAUTH.get(`/api/v1/admin/summary/export/excel/${id}`).then(res => {
				const data = res.data.data;
				window.location.href = data.download_link;
			}).catch(eres => {
				showErrorMessage(eres);
			})
		}
  },
  filters: {
    populateTable(items) {
      var data = "";
      for (var i in items) {
        data += `${items[i]}</td><td>`
      }
      return data;
    }
  }
};
</script>